module.exports = __webpack_public_path__ + "static/media/carroussel_18.0dff7f7f.jpg";